<form [formGroup]="JudgeForm" (ngSubmit)="Submit(JudgeForm)" novalidate>
    <h1 mat-dialog-title><span *ngIf="Judge">Edit</span><span *ngIf="!Judge">Add</span> Judge</h1>
    <div mat-dialog-content>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>First Name</span></div>
            <mat-form-field appearance="outline">
                <input type="text" matInput placeholder="First Name" formControlName="FirstName" required />
                <mat-error *ngIf="JudgeForm.get('FirstName')?.hasError('required')">required</mat-error>
                <mat-error *ngIf="JudgeForm.get('FirstName')?.hasError('maxlength')">name too long</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>Last Name</span></div>
            <mat-form-field appearance="outline">
                <input type="text" matInput placeholder="Last Name" formControlName="LastName" required />
                <mat-error *ngIf="JudgeForm.get('LastName')?.hasError('required')">required</mat-error>
                <mat-error *ngIf="JudgeForm.get('LastName')?.hasError('maxlength')">name too long</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>Email</span></div>
            <mat-form-field appearance="outline">
                <input type="text" matInput placeholder="Email" formControlName="Email" required />
                <mat-error *ngIf="JudgeForm.get('Email')?.hasError('required')">required</mat-error>
                <mat-error *ngIf="JudgeForm.get('Email')?.hasError('maxlength')">email too long</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>Judging Phase</span></div>
            <mat-form-field appearance="outline">
                <mat-select formControlName="JudgingPhase" placeholder="Select phase...">
                    <mat-option [value]="null">Select phase...</mat-option>
                    <mat-option *ngFor="let phase of Phases" [value]="phase.Value">{{phase.Display}}</mat-option>
                </mat-select>
                <mat-error *ngIf="JudgeForm.get('JudgingPhase')?.hasError('required')">required</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>District</span></div>
            <mat-form-field appearance="outline">
                <mat-select formControlName="DistrictNumber" placeholder="Select district...">
                    <mat-option [value]="null">Select district...</mat-option>
                    <mat-option *ngFor="let dist of Districts" [value]="dist">{{dist}}</mat-option>
                </mat-select>
                <mat-hint>For Final Juding Round, select '0'</mat-hint>
                <mat-error *ngIf="JudgeForm.get('DistrictNumber')?.hasError('required')">required</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>Nominee Type</span></div>
            <mat-form-field appearance="outline">
                <mat-select formControlName="NomineeTypeID" placeholder="Select nominee type...">
                    <mat-option [value]="null">Select nominee type...</mat-option>
                    <mat-option *ngFor="let nt of NomineeTypes" [value]="nt.NomineeTypeID">{{nt.Description}}</mat-option>
                </mat-select>
                <mat-error *ngIf="JudgeForm.get('NomineeTypeID')?.hasError('required')">required</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" *ngIf="Judge == null">
            <div><span>Send judge announcement email?</span></div>
            <mat-checkbox formControlName="SendEmail"></mat-checkbox>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button type="button" [color]="'accent'" (click)="CancelHandler()">Cancel</button>
        <button mat-raised-button type="submit" [color]="'primary'">Submit</button>
    </div>
</form>